/**
 * useMemberType for a group
 */

import { useState } from 'react';
import { STUDENT_ROLE, GROUPTYPES_CLASS } from 'containers/User/constants.js';
import { useApi2, useApi2call } from 'containers/Api2/index.js';
import useDialog from 'containers/Dialog/useDialog.js';
import messages from './messages.js';

const PAGESIZE = 10;

function useMemberType(group, memberType, search) {
  const { id: groupId, groupType, typeName } = group;
  const showInviteStudents = memberType.id === STUDENT_ROLE && groupType === GROUPTYPES_CLASS;
  const [show, setShow] = useState(false);
  const { dlgClick } = useDialog();
  const api2call = useApi2call();
  const baseUrl = `sa/groups/${groupId}/members`;
  const selector = `sa/groups/${typeName}/${groupId}/members/${memberType.id}`;
  const q = search ? `q=${encodeURIComponent(search)}&` : '';
  const loadOptions = {
    url: `${baseUrl}?${q}&type=${memberType.id}&offset=0&limit=${PAGESIZE}`,
    selector,
    version: 2,
    name: 'members',
    autoNext: (show || showInviteStudents) && 20,
  };
  const members = useApi2(loadOptions);
  if (members.error) {
    throw new Error(members.error);
  }

  function handleAdd(data) {
    const newMembers = data
      .filter((o) => !members.list.includes(o.id))
      .map((o) => ({ id: o.id, type: memberType.id }));
    if (members.length === 0) {
      return;
    }
    api2call({
      method: 'POST',
      url: baseUrl,
      selector,
      version: 2,
      body: { members: newMembers },
      success: messages.membersAdded,
      withPromise: true,
    }).then(() => {
      api2call({ ...loadOptions, reload: true });
      setShow(false);
    });
  }

  function handleDelete(user) {
    api2call({
      method: 'DELETE',
      url: `${baseUrl}/${memberType.id}/${user.id}`,
      selector: `${selector}/${user.id}`,
      version: 2,
      success: messages.membersRemoved,
    });
  }

  function callHandleAddAll() {
    api2call({
      method: 'POST',
      url: `${baseUrl}/all`,
      selector,
      version: 2,
      body: { type: memberType.id },
      success: messages.membersAdded,
      withPromise: true,
    }).then(() => {
      api2call({ ...loadOptions, reload: true });
      setShow(false);
    });
  }

  function handleAddAll(message) {
    dlgClick({ message }, callHandleAddAll);
  }

  const getUploadAvatarOptions = (id) => ({
    selector: `${selector}/${id}`,
    url: `sa/users/student/${id}/avatar`,
    version: 2,
  });

  return { members, handleAdd, handleAddAll, handleDelete, getUploadAvatarOptions };
}

export default useMemberType;
